export function getRemainingMs(unixTime: number): number {
  if (typeof unixTime !== 'string' && typeof unixTime !== 'number') {
    throw new Error(`Timestamp inválido: ${unixTime}`);
  }
  const raw = typeof unixTime === 'string' ? parseInt(unixTime, 10) : unixTime;
  if (isNaN(raw)) {
    throw new Error(`Timestamp inválido: ${unixTime}`);
  }

  const expirationMs = raw < 1e12 ? raw * 1000 : raw;

  const now = Date.now();
  const delta = expirationMs - now;

  return delta > 0 ? delta : 0;
}
